import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {DataService} from '../../data/data.service';
// import {SettingsModule} from '../../../modules/settings/settings.module';

export const notificationUrl     = 'api/Notification';
const BaseUrl = environment.BaseUrl ;

@Injectable({
  providedIn: 'root'
})
export class NotificationsService extends DataService{

  constructor(http: HttpClient) {
    super(notificationUrl, BaseUrl, http, "Notification" );
  }
}
